import { FC, memo } from 'react'
import { Box, Flex, Image, Text } from '@chakra-ui/react'

import { convertBytesNumberToString } from 'utils/transforms/number'
import getAssets from 'utils/assets/getAssets'

type File = {
  name?: string
  extension?: string
  size?: number
}

type Props = {
  file: File
}

const FileItem: FC<Props> = ({ file }) => {
  const fileImage = getAssets('File', file.extension ? file.extension.toLowerCase() : '')

  return (
    <Flex align="center" gap={2}>
      <Image boxSize="40px" backgroundSize="cover" src={fileImage} alt={file.name} />
      <Box>
        <Text wordBreak="break-word">{file.name}</Text>
        <Text textAlign="left" variant="secondary">
          {file.extension ? file.extension.toUpperCase() : ''}, {convertBytesNumberToString(file.size)}
        </Text>
      </Box>
    </Flex>
  )
}

export default memo(FileItem)
